import { IIndexable } from 'core-ts-types';
import { merge } from 'lodash4';
import { ITreeNode } from 'utility-ts-type';
import { ap_course_status_type } from '../strategies/ap_course_status_strategy';
import { APCourse } from './ap_course_builder';

export class PlannedCourse implements IIndexable, ITreeNode {
  id: number;
  term: number;
  program_slot: number;
  course: Partial<APCourse>;
  is_prereq_satisfied: boolean;
  is_prereq_course_satisfied: boolean;
  is_prereq_grade_satisfied: boolean;
  is_coreq_satisfied: boolean;
  prereq_miss: [number];
  prereq_outoforder: [number];
  coreq_miss: [number];
  coreq_outoforder: [number];
  status: ap_course_status_type;

  constructor(block: Partial<PlannedCourse>) {
    merge(this, block);
  }

  static build(block: Partial<PlannedCourse>): PlannedCourse {
    return new PlannedCourse(block);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/builders/planned_course_builder.ts